import { Upload } from 'antd';
import axios from 'axios';
import { RevxButton } from '../../../../components/RevxButton';

const FileAdminContainer = () => {
  const type =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  return (
    <div>
      <Upload
        multiple={false}
        maxCount={1}
        customRequest={async ({ file, onSuccess }) => {
          const formData = new FormData();
          formData.append('file', file);
          const authToken = localStorage.getItem('Authorization') ?? '';
          const { data: blobData } = await axios.post(
            `${process.env.REACT_APP_API_URL}/payments/balance/invoice/fix`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: authToken,
              },
              responseType: 'blob',
            }
          );
          const data =
            blobData instanceof Blob
              ? blobData
              : new Blob([JSON.stringify(blobData)], { type });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(data);
          a.download = 'result.xlsx';
          a.click();
          const xhr = new XMLHttpRequest();
          onSuccess?.('ok', xhr);
        }}
      >
        <RevxButton>Click to Upload</RevxButton>
      </Upload>
    </div>
  );
};

export default FileAdminContainer;
